export const DEVELOPMENT_CENTERS_SOURCES = {
    LOCAL: 'local',
    LMS: 'lms',
};
